import { ChangeDetectorRef, Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'gtd-payment-system-field',
  templateUrl: './payment-system-field.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PaymentSystemFieldComponent),
    },
  ],
})
export class PaymentSystemFieldComponent {
  @Input() label = 'Payment System';
  @Input() required = true;
  @Input() readonly = false;
  @Input() data: { [key: string]: any };

  public control: UntypedFormControl;
  public selectedData: string;

  constructor(private cd: ChangeDetectorRef) {}

  public onChange: (value: string) => void = () => {};
  public onTouch = () => {};

  registerOnChange(fn: (value) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  writeValue(value: string): void {
    this.selectedData = value;
    this.onChange(this.selectedData);
    this.cd.markForCheck();
  }
}
